import { jsx as l } from "react/jsx-runtime";
const t = (e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...e,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentcolor",
        fillRule: "evenodd",
        d: "M12 2a10 10 0 0 0-.04 20 2.3 2.3 0 0 0 1.718-3.985 1 1 0 0 0-.194-.14 1 1 0 0 1 .5-1.875H16.5c1.423 0 2.808-.502 3.846-1.424C21.388 13.65 22 12.366 22 11c0-2.427-1.086-4.728-2.972-6.404C17.146 2.923 14.617 2 12 2m0 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M7.5 9a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m9 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3",
        clipRule: "evenodd"
      }
    )
  }
);
export {
  t as default
};
